/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TarfStatusDetail = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        count: {
    type: 'number',
    isRequired: true,
},
    },
};